import { FormattedMessage, useIntl } from 'react-intl';

import { Modal } from '../../../../common';
import { SubmitModalProps } from './submit-modal.models';
import { useStyles } from './submit-modal.styles';
import { ReactNode } from 'react';

export const SubmitModal = ({ isCancel, ...props }: SubmitModalProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Modal
      {...props}
      data-testid="submit-unsubscribe-modal"
      title={isCancel ? <FormattedMessage id="unsubscribe.cancel" /> : <FormattedMessage id="unsubscribe.submit" />}
      titleStyles={classes.title}
      propsPaperStyles={classes.paper}
      content={!isCancel && intl.formatMessage({ id: 'unsubscribe.submit.text' }, {  sup: (chunks: ReactNode) => <sup>{chunks}</sup> })}
      propsContentStyles={classes.content}
    />
  );
};
